import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '../../../../@commons/ui-components/shared.module';
import { MyCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/my-cultivation-list.response';
import { NgClass } from '@angular/common';
import { HexToHsl } from '../../../../@commons/pipes/HexToHsl';
import { CalendarCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-list.response';
import { DEFAULT_CULTIVATION_IMAGE, lastFileUrl } from '../../last-file-url.util';

@Component({
  selector: 'vw-cultivation-item-viewer',
  imports: [SharedModule, NgClass, HexToHsl],
  templateUrl: './cultivation-item-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cultivation-item-viewer.component.scss'
})
export class CultivationItemViewerComponent implements OnChanges {
  @Input() cultivation!:
    | MyCultivationListResponse
    | CalendarCultivationListResponse;
  @Input() displayType: 'BIG' | 'SMALL' | 'TINY' = 'BIG';
  @Input() showName: boolean = false;
  imageUrl: string = DEFAULT_CULTIVATION_IMAGE;

  ngOnChanges() {
    this.imageUrl = lastFileUrl(this.cultivation, DEFAULT_CULTIVATION_IMAGE);
  }
}
